import React from 'react';

import { SVGIcon } from '@uikit/old/Icon/Icon';
import { ChangeRequestStatus } from 'respona_api/generated/order-publisher_pb';
import {
  ChangeRequestStatusValueType,
  changeRequestStatusConfig,
  hasChangeRequest,
} from '@components/Publisher/Orders/OrdersTable/constants';

import './ConcernStatusLabel.scss';

/**
 * "Active" means the publisher still has something to act on. A resolved change
 * request is not active, but is still rendered (and viewable) so publishers can
 * read the history back after it closes.
 */
export const isActiveConcernStatus = (status?: ChangeRequestStatusValueType): boolean =>
  status === ChangeRequestStatus.CHANGES_REQUESTED ||
  status === ChangeRequestStatus.CHANGE_REQUEST_IN_REVIEW;

function ConcernStatusLabel({
  status,
  onView,
  testId,
}: {
  status: ChangeRequestStatusValueType;
  onView: () => void;
  /** data-testid on the label; the View button gets `${testId}-view` */
  testId?: string;
}): JSX.Element {
  const config = changeRequestStatusConfig[status];

  if (!config || !hasChangeRequest(status)) {
    return null;
  }

  const handleView = (event: React.MouseEvent) => {
    event.stopPropagation();
    onView();
  };

  return (
    <div
      className={`concern-status-label concern-status-label--${config.modifier}`}
      data-testid={testId}
      data-status={status}
    >
      <SVGIcon icon={config.icon} color={config.iconColor} size={12} />
      <span className="concern-status-label__title">{config.title}</span>
      <button
        type="button"
        className="concern-status-label__view"
        onClick={handleView}
        data-testid={testId ? `${testId}-view` : undefined}
      >
        View
      </button>
    </div>
  );
}

export default ConcernStatusLabel;
